import React from 'react';
import BaseModal from 'src/common/components/Modal';
import notice from 'src/common/components/Notice';
import { institutionsAPI } from 'src/api/modules/institutions';

const DeleteOrg = ({ open, onClose, onSuccess, organization }) => {
	const onDeleteData = () => {
		institutionsAPI
			.institutionDelete(organization.id)
			.then(() => {
				onSuccess('Eliminado correctamente', 'success', 3);
			})
			.catch(() => {
				notice('Ha ocurrido un error en su solicitud');
			});
	};
	return (
		<BaseModal
			open={open}
			mainText="Eliminar Organización"
			confirmLabel="Si, eliminar"
			onConfirm={onDeleteData}
			onClose={onClose}
			onCancel={onClose}
		>
			<p>
				<font size="4">
					Esta seguro que desea eliminar <strong>{organization.nombre}</strong>
				</font>
			</p>
		</BaseModal>
	);
};

export default DeleteOrg;
